import { useQuery, UseQueryOptions } from 'react-query';

import { CreditCard } from 'types/interfaces/CreditCard';

import { PaymentApi } from 'api/PaymentApi';

export const usePaymentCardQuery = (
  queryOptions?: UseQueryOptions<{
    card: CreditCard;
    last_decline_type: string;
  }>
) => {
  const paymentCardQueryKey = 'payment-card';

  const paymentCardQuery = useQuery<{
    card: CreditCard;
    last_decline_type: string;
  }>(
    paymentCardQueryKey,
    async () => {
      const { data } = await PaymentApi.fetchCreditCard();

      if (!data.card) {
        throw new Error('Card must not be null');
      }

      return data;
    },
    {
      retry: 10,
      retryDelay: 1500,
      cacheTime: 0,
      ...queryOptions,
    }
  );

  return {
    paymentCardQueryKey,
    paymentCardQuery,
  };
};
